// @ts-nocheck
import {Column} from 'react-table'
import {UserCustomHeader} from '../../apps/user-management/users-list/table/columns/UserCustomHeader'
import {Product, deleteProduct} from './api'
import {KTIcon} from '../../../../_metronic/helpers'
import {Modal} from 'react-bootstrap'
import {toast} from 'react-hot-toast'
import {useState} from 'react'
import {useLayout} from '../../../../_metronic/layout/core'

const getProductColumns = (
  setShowForm: React.Dispatch<React.SetStateAction<boolean>>,
  setEditProduct: React.Dispatch<React.SetStateAction<Product | undefined>>,
  setShouldRefreshProducts: React.Dispatch<React.SetStateAction<boolean>>
): ReadonlyArray<Column<Product>> => [
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='Product Name'
        className='min-w-150px ps-4 text-center'
      />
    ),
    id: 'product_name',
    accessor: 'product_name',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='SKU Code' className='min-w-125px text-center' />
    ),
    accessor: 'sku_code',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Category' className='min-w-125px text-center' />
    ),
    accessor: 'category',
    sortType: 'string',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Unit' className='min-w-100px text-center' />
    ),
    accessor: 'unit',
    sortType: 'string',
  },
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='Price / Unit'
        className='min-w-125px text-center'
      />
    ),
    accessor: 'price_per_unit',
    sortType: 'basic',
    Cell: ({...props}) => {
      return <div>&#8377; {props.data[props.row.index].price_per_unit}</div>
    },
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Status' className='min-w-100px text-center' />
    ),
    accessor: 'status',
    sortType: 'string',
    Cell: ({...props}) => {
      const status = props.data[props.row.index].status
      return (
        <span
          className={`badge fw-bold ${
            status === 'active' ? 'badge-light-success' : 'badge-light-danger'
          }`}
        >
          {status.toUpperCase()}
        </span>
      )
    },
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='min-w-100px text-center' />
    ),
    accessor: 'actions',
    sortable: false,
    Cell: ({...props}) => {
      const {company} = useLayout()
      const [showDeleteModal, setShowDeleteModal] = useState(false)

      const handleDelete = async () => {
        deleteProduct(company.value, props.data[props.row.index].product_id)
          .then((res) => res?.detail && toast.success(res.detail))
          .catch((err) => err && toast.error(err))
          .finally(() => {
            setShouldRefreshProducts(true)
            setShowDeleteModal(false)
          })
      }

      const handleEdit = () => {
        setShowForm(true)
        setEditProduct(props.data[props.row.index])
      }

      return (
        <>
          <div className='d-flex justify-content-center flex-shrink-0'>
            <div
              onClick={handleEdit}
              data-bs-toggle='tooltip'
              data-bs-trigger='hover'
              data-bs-dismiss-='click'
              title='Edit'
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </div>
            <div
              data-bs-toggle='tooltip'
              data-bs-trigger='hover'
              data-bs-dismiss-='click'
              title='Mark Inactive'
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
              onClick={() => setShowDeleteModal(true)}
            >
              <KTIcon iconName='trash' className='fs-3' />
            </div>
          </div>

          <Modal
            className='modal-sticky modal-sticky-lg modal-sticky-bottom-right'
            id='delete_product'
            role='dialog'
            data-backdrop='false'
            aria-hidden='true'
            tabIndex='-1'
            show={showDeleteModal}
            animation={false}
          >
            <div className='modal-content'>
              {/*begin::Header*/}
              <div className='d-flex align-items-center justify-content-between py-5 ps-8 pe-5 border-bottom'>
                <h5 className='fw-bold m-0'>Mark Product Inactive</h5>
                <div className='d-flex ms-2'>
                  {/*begin::Close*/}
                  <div
                    className='btn btn-icon btn-sm btn-light-primary ms-2'
                    data-bs-dismiss='modal'
                    onClick={() => setShowDeleteModal(false)}
                  >
                    <KTIcon className='fs-1' iconName='cross' />
                  </div>
                  {/*end::Close*/}
                </div>
              </div>
              {/*end::Header*/}
              <div className='text-center py-5 px-5'>
                This product will be marked inactive and removed from inventory transaction
                dropdowns. Historical records will be preserved.
              </div>
              <div className='text-center pt-5 pb-5'>
                <button
                  type='reset'
                  onClick={() => setShowDeleteModal(false)}
                  className='btn btn-light me-3'
                  data-kt-users-modal-action='cancel'
                >
                  Cancel
                </button>
                <button
                  type='submit'
                  className='btn btn-primary'
                  data-kt-users-modal-action='submit'
                  onClick={handleDelete}
                >
                  Proceed
                </button>
              </div>
            </div>
          </Modal>
        </>
      )
    },
  },
]

export {getProductColumns}
